import request from '@/utils/request'

/*
 * 获取单条帮助信息
 * @param params
 * @return promise对象
 */
export function ADS_GET(params) {
  return request({
    url: `/pub/design/ad`,
    method: 'get',
    params
  })
}

// MODEL 定义的变量
export const VARS = {
  // 端
  PORTAL: {
    WEB: {
      value: '1',
      label: 'PC'
    },
    MOBILE: {
      value: '2',
      label: 'MOB'
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/design/ad.js